import React from 'react'
import PropTypes from 'prop-types'

import request from 'utils/request'
import { connect } from 'react-redux'

import { Link } from 'react-router-dom'

import Input from 'components/Input'
import Button from 'components/Button'
import RequestStatus from 'components/RequestStatus'
import BasePureComponent from 'utils/BasePureComponent'

import { reverse } from 'routes'
import { PASSWORD_RECOVERY_URL } from 'constants'
import { emailChanged, nextStep } from 'scenes/PasswordRecovery/actions'

import './style.scss'


export class Form extends BasePureComponent {
  constructor(props) {
    super(props);

    this.state = {
      buttonProps: {},
      request: {
        status: '',
        message: ''
      },
      errors: {
        email: []
      }
    }

    this._bind('_onSubmit', '_renderInvalidToken')
  }

  // we need to use asyn-await here in order to test it :(
  // TODO: find a way that avoids using async-await
  async _onSubmit(e) {
    e.preventDefault()
    this.setState({
      buttonProps: { disabled: true },
      request: {
        status: 'progress',
        message: 'Iniciando sesión...'
      }
    })

    await request(PASSWORD_RECOVERY_URL, {
      method: 'POST',
      body: {
        email: this.props.email
      }
    })
    .then((response) => {
      this.props.nextStep()
    })
    .catch(({response}) => {
      const errors = !!response.fields ? {...response.fields} : {}
      this.setState({
        buttonProps: {},
        request: {
          status: response.status,
          message: response.message
        },
        errors: {...errors}
      })
    })
  }

  _renderInvalidToken() {
    const locationState = this.props.location.state
    return !!locationState && locationState.status === 'error' ? (
      <p className="PasswordRecovery__invalid-token">Tu link ya ha sido usado o no es válido, por favor intenta nuevamente</p>
    ) : null
  }

  render() {
    return (
      <div>
        <div>
          {this._renderInvalidToken()}
        </div>
        <div className="PasswordRecovery__form__section_title row align-items-center">
          <h5 className="col-md-7">Recuperar contraseña</h5>
          <div className="col-md-5">
            <Link to={reverse('accounts:login')} replace className="Button btn btn-inverse ">
              Iniciar sesión
            </Link>
          </div>
        </div>
        <form onSubmit={this._onSubmit} className="PasswordRecovery__form">
          <div className="PasswordRecovery__form__fields">
            <Input
              type="email"
              icon="email"
              tabIndex="1"
              name="email"
              size="big"
              required
              autoFocus
              value={this.props.email}
              onChange={this.props.onEmailChange}
              errors={this.state.errors.email}
              placeholder="Correo electrónico"
            />
          </div>
          <div className="PasswordRecovery__form__indicator">
            <RequestStatus
              status={this.state.request.status}
              message={this.state.request.message}/>
          </div>
          <div className="PasswordRecovery__form__description">
            <p className="paragraph-text-bold paragraph-small ">
              Ingresa el correo electrónico de tu cuenta y pronto te enviaremos las instrucciones para recuperar tu contraseña
            </p>
          </div>
          <div className="PasswordRecovery__form__actions align-items-center">
            <div className="col-md-10">
              <Button
                type="submit"
                buttonType="primary"
                tabIndex="3"
                size="big"
                {...this.state.buttonProps}
              >
                Recuperar contraseña
              </Button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

Form.contextTypes = {
  router: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    email: state.passwordRecovery.get('email')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onEmailChange: (evt) => dispatch(emailChanged(evt.target.value)),
    nextStep: () => dispatch(nextStep())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form)



// WEBPACK FOOTER //
// ./src/scenes/PasswordRecovery/components/Form/index.js